import AppImage from '@/components/ui/AppImage';
import Icon from '@/components/ui/AppIcon';

interface EntertainmentCardProps {
  name: string;
  category: string;
  distance: string;
  image: string;
  alt: string;
  description: string;
  highlights: string[];
  openingHours: string;
}

const EntertainmentCard = ({
  name,
  category,
  distance,
  image,
  alt,
  description,
  highlights,
  openingHours,
}: EntertainmentCardProps) => {
  return (
    <div className="bg-card rounded-xl shadow-subtle hover:shadow-elevated transition-all duration-300 overflow-hidden border border-border">
      <div className="relative h-56 overflow-hidden">
        <AppImage
          src={image}
          alt={alt}
          className="w-full h-full object-cover hover:scale-110 transition-transform duration-500"
        />
        <div className="absolute top-4 left-4 bg-accent/90 backdrop-blur-sm px-4 py-2 rounded-full">
          <p className="text-sm font-semibold text-white">{category}</p>
        </div>
      </div>
      
      <div className="p-6">
        <div className="flex items-start justify-between mb-3">
          <h3 className="font-display text-xl font-semibold text-text-primary flex-1">
            {name}
          </h3>
          <div className="flex items-center space-x-1 text-text-secondary ml-4">
            <Icon name="MapPinIcon" size={16} />
            <span className="text-sm">{distance}</span>
          </div>
        </div>
        
        <p className="text-text-secondary mb-4">{description}</p>
        
        <div className="space-y-2 mb-4">
          {highlights.map((highlight, index) => (
            <div key={index} className="flex items-start space-x-2">
              <Icon name="CheckCircleIcon" size={18} className="text-success flex-shrink-0 mt-0.5" />
              <span className="text-sm text-text-secondary">{highlight}</span>
            </div>
          ))}
        </div>
        
        <div className="pt-4 border-t border-border flex items-center space-x-2">
          <Icon name="ClockIcon" size={18} className="text-text-secondary" />
          <span className="text-sm text-text-secondary">{openingHours}</span>
        </div>
      </div>
    </div>
  );
};

export default EntertainmentCard;